import React, {useState} from "react";

const MultipleChoiceBlock = ({config, onComplete}) => {
    const {
        prompt,
        options = [],
        correctOptionIds = [],
        explanation
    } = config || {};

    const [selectedOptionIds, setSelectedOptionIds] = useState([]);
    const [isChecked, setIsChecked] = useState(false);

    const isCorrect =
        isChecked &&
        selectedOptionIds.length === correctOptionIds.length &&
        selectedOptionIds.every((id) =>
            correctOptionIds.includes(id)
        );

    const handleOptionClick = (optionId) => {
        if (isChecked) return;

        setSelectedOptionIds((prev) => {
            if (prev.includes(optionId)) {
                return prev.filter((id) => id !== optionId);
            }

            return [...prev, optionId];
        });
    };

    const handleCheck = () => {
        if (selectedOptionIds.length === 0 || isChecked) {
            return;
        }

        setIsChecked(true);

        if (
            selectedOptionIds.length === correctOptionIds.length &&
            selectedOptionIds.every((id) =>
                correctOptionIds.includes(id)
            )
        ) {
            onComplete?.();
        }
    };

    return (
        <div className="w-full flex flex-col gap-5">

            {/* Question */}
            <div className="text-lg font-semibold leading-8">
                {prompt?.blocks?.map((block) => (
                    <PromptBlock
                        key={block.id}
                        block={block}
                    />
                ))}
            </div>

            {/* Options */}
            <div className="flex flex-col gap-3">
                {options.map((option) => {
                    const selected =
                        selectedOptionIds.includes(option.id);

                    const correct =
                        isChecked &&
                        correctOptionIds.includes(option.id);

                    const incorrect =
                        isChecked &&
                        selected &&
                        !correctOptionIds.includes(option.id);

                    return (
                        <button
                            key={option.id}
                            type="button"
                            disabled={isChecked}
                            onClick={() =>
                                handleOptionClick(option.id)
                            }
                            className={`
                                w-full
                                rounded-xl
                                border
                                p-4
                                text-right
                                transition
                                ${
                                correct
                                    ? "border-green-500 bg-green-50"
                                    : incorrect
                                        ? "border-red-500 bg-red-50"
                                        : selected
                                            ? "border-blue-500 bg-blue-50"
                                            : "border-gray-200 bg-white hover:border-gray-400"
                            }
                            `}
                        >
                            {option.text}
                        </button>
                    );
                })}
            </div>

            {/* Check */}
            {!isChecked && (
                <button
                    type="button"
                    disabled={selectedOptionIds.length === 0}
                    onClick={handleCheck}
                    className="
                        w-full
                        rounded-xl
                        bg-black
                        px-5
                        py-3
                        text-white
                        disabled:opacity-40
                    "
                >
                    بررسی
                </button>
            )}

            {/* Result */}
            {isChecked && (
                <div
                    className={`
                        rounded-xl
                        p-4
                        leading-7
                        ${
                        isCorrect
                            ? "bg-green-50 text-green-800"
                            : "bg-red-50 text-red-800"
                    }
                    `}
                >
                    {isCorrect
                        ? "درست است!"
                        : "پاسخ اشتباه است."
                    }
                </div>
            )}

            {/* Explanation */}
            {isChecked && explanation?.blocks && (
                <div className="rounded-xl bg-gray-50 p-4">
                    {explanation.blocks.map((block) => (
                        <PromptBlock
                            key={block.id}
                            block={block}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

const PromptBlock = ({block}) => {
    if (block.type === "text") {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: block.config?.text || ""
                }}
            />
        );
    }

    return null;
};

export default MultipleChoiceBlock;